import { lazy } from 'react';

/**
 * The signed-out pages and the auth screens.
 *
 * This is one of the two places the app root is allowed to reach into
 * `src/modules` — the bridge that keeps the rest of the dependency arrow
 * pointing one way. Every page is lazy, so each is its own chunk.
 */
export const Home = lazy(() => import('../modules/landing/pages/Home'));
export const Catalogue = lazy(() => import('../modules/landing/pages/Catalogue'));
export const ContactUs = lazy(() => import('../modules/landing/pages/Contact'));
export const CertificateDetails = lazy(() => import('../modules/landing/pages/CertificateDetails'));
export const PrivacyPolicy = lazy(() => import('../modules/landing/pages/PrivacyPolicy'));
export const TermsAndConditions = lazy(() => import('../modules/landing/pages/TermsAndConditions'));

export const Signin = lazy(() => import('../modules/auth/pages/Signin'));
export const Signup = lazy(() => import('../modules/auth/pages/Signup'));
export const Activation = lazy(() => import('../modules/auth/pages/Activation'));
export const ForgotPassword = lazy(() => import('../modules/auth/pages/ForgotPassword'));
export const ResetPassword = lazy(() => import('../modules/auth/pages/ResetPassword'));
export const CheckEmail = lazy(() => import('../modules/auth/pages/CheckEmail'));

/**
 * Chrome for these pages, re-exported through this file on purpose, so the
 * bridge to `src/modules` stays this one file for the signed-out side.
 *
 * `V2Root` — which carries `dir`, `lang` and the module stylesheet — is wanted
 * by the student side too, so it sits in `shared`.
 */
export { isV2AuthRoute, isLegacyPublicRoute } from '../modules/shared/routes';
export { V2Root } from '../modules/shared/components';
export {
    NavBar as NavBarV2,
    Footer as FooterV2,
} from '../modules/landing/components/shared';
